import { render, staticRenderFns } from "./notification-snackbars.vue?vue&type=template&id=4f1ef9c2&scoped=true&"
import script from "./notification-snackbars.vue?vue&type=script&lang=js&"
export * from "./notification-snackbars.vue?vue&type=script&lang=js&"
import style0 from "./notification-snackbars.vue?vue&type=style&index=0&id=4f1ef9c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../@vue-modules/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1ef9c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../@vue-modules/vuetify/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VSnackbar})
